export { default } from './PercentSlider';
